<template>
    <div>
        <sui-input :type="currentValue.inputType" :value="currentValue.value" @input="$emit('updateValue', $event)" />
    </div>
</template>

<script>

export default {
    name: 'ModuleInput',
    data () {
        return {
            currentValue: {}
        }
    },
    props: {
        parameters: {
            type: Object,
        },
    },
    watch: {
        currentValue: {
            handler(val) {
                this.$emit('parameters-update', val);
            },
            deep: true
        }
    },
    mounted() {
        this.currentValue = JSON.parse(JSON.stringify(this.parameters));
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
